import { observable, action } from 'mobx'
import { SearchList } from '@services/api'
import UserStore from './UserStore'

class Search {
  @observable public searchWord = ''
  @observable public searchWordAfter = ''
  @observable public dataList = ''
  @observable public tags = []
  @observable public routeParam = 'search'
  @observable public loading = 'false'
  @observable public haveMore = 'false'
  @observable public liveList = []
  @observable public shortVideoList = [] as any
  @observable public playBackList = []
  @observable public inforList = []
  @observable public trainList = []
  @observable public seminarList = []
  @observable public enterPriseList = []
  @observable public pageNumber = 1
  @observable public knowledgeList = []
  @observable public fileList = []
  @observable public topicList = [] // 圈子
  @observable public postList = [] // 帖子
  @observable public LiteListData = [] as any // 短视频菜单数据
  @observable public LiteScroll = 0
  @observable public LiteHasData = true

  @observable public pageNumberLive = 1
  @observable public pageNumberPlayBack = 1
  @observable public pageNumberInfor = 1
  @observable public pageNumberTrain = 1
  @observable public pageNumberEnterPrise = 1
  @observable public pageNumberSeminar = 1
  @observable public pageNumberKnowledge = 1
  @observable public pageNumberFile = 1
  @observable public pageNumberTopic = 1
  @observable public pageNumberPost = 1
  @observable public pageNumberShortVideo = 1

  @action
  public updatePageNumber = (value: number) => {
    this.pageNumber = value
  }

  @action
  public updatePageNumberLive = (value: number) => {
    this.pageNumberLive = value
  }

  @action
  public updatePageNumberPlayBack = (value: number) => {
    this.pageNumberPlayBack = value
  }

  @action
  public updatePageNumberInfor = (value: number) => {
    this.pageNumberInfor = value
  }

  @action
  public updatePageNumberTrain = (value: number) => {
    this.pageNumberTrain = value
  }

  @action
  public updatePageNumberEnterPrise = (value: number) => {
    this.pageNumberEnterPrise = value
  }

  @action
  public updatePageNumberSeminar = (value: number) => {
    this.pageNumberSeminar = value
  }
  @action
  public updatePageNumberKnowledge = (value: number) => {
    this.pageNumberKnowledge = value
  }
  @action
  public updatePageNumberFile = (value: number) => {
    this.pageNumberFile = value
  }

  @action
  public updateSearchWord = (value: any) => {
    this.searchWord = value
  }
  @action
  public updateSearchWordAfter = (value: any) => {
    this.searchWordAfter = value
  }
  @action
  public updateRouteParam = (value: any) => {
    this.routeParam = value
  }
  @action
  public updateDataList = (value: any) => {
    this.dataList = value
  }

  @action
  public updateLoading = (value: any) => {
    this.loading = value
  }

  @action
  public updateHaveMore = (value: any) => {
    this.haveMore = value
  }
  @action
  public updateLiveList = (value: any) => {
    this.liveList = value
  }
  @action
  public updatePlayBackList = (value: any) => {
    this.playBackList = value
  }

  @action
  public updateInforList = (value: any) => {
    this.inforList = value
  }

  @action
  public updateTrainList = (value: any) => {
    this.trainList = value
  }
  @action
  public updateSeminarList = (value: any) => {
    this.seminarList = value
  }
  @action
  public updateEnterPriseList = (value: any) => {
    this.enterPriseList = value
  }
  @action
  public updateKnowledgeList = (value: any) => {
    this.knowledgeList = value
  }
  @action
  public updateFileList = (value: any) => {
    this.fileList = value
  }
  @action
  public updatePageNumberTopic = (value: number) => {
    this.pageNumberTopic = value
  }
  @action
  public updatePageNumberPost = (value: number) => {
    this.pageNumberPost = value
  }
  @action
  public updateTopicList = (value: any) => {
    this.topicList = value
  }
  @action
  public updatePostList = (value: any) => {
    this.postList = value
  }

  @action
  public updateLiteListData = (value: any) => {
    this.LiteListData = value
  }

  @action
  public updateLiteScroll = (value: any) => {
    this.LiteScroll = value
  }

  @action
  public updateLiteHasData = (value: any) => {
    this.LiteHasData = value
  }

  // 全部列表
  public getAllList = async () => {
    this.updateDataList('')
    const searchWord = this.searchWord
    const homeId = UserStore.homeId
    global.$showLoading(true)
    this.updateLoading(true)
    const { body, code, message }: any = await SearchList.searchList(
      UserStore.sid,
      this.pageNumber,
      searchWord,
      homeId
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (parseInt(code, 10) === 0) {
      this.updateDataList(body || [])
    } else if (code * 1 !== -4) {
      global.$message(message, { variant: 'error' })
    }
  }

  // 直播
  @action
  public getLiveList = async (
    pageNumberLive: number,
    isSchoolLive?: boolean
  ) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const { code, body, message }: any = await SearchList.getLiveListMore(
      pageNumberLive,
      searchWord,
      isSchoolLive
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === -4) {
      return
    } else if (+code !== 0) {
      global.$message(message, { variant: 'error' })
    } else if (!!body) {
      const temp = body.page || {}
      const data = temp.data || []
      this.updateLiveList([...this.liveList, ...data]),
        this.updatePageNumberLive(this.pageNumberLive + 1),
        this.updateHaveMore(data.length >= 15)
    } else {
      this.updateHaveMore(true)
    }
  }

  // 短视频、学堂短视频
  @action
  public getShortVideoList = async (pageNo: number, isSchoolLive?: boolean) => {
    const keyword = this.searchWord
    const pageNumberShortVideo = pageNo || this.pageNumberShortVideo
    global.$showLoading(true)
    this.updateLoading(true)
    // const enterpriseId = '0DE29484A7187032E054A0369F1934EC'
    // const videoType = UserStore.enterpriseId === enterpriseId ? 1 : 2
    const res: any = await SearchList.queryLittleVideoList({
      pageNo: pageNumberShortVideo,
      pageSize: 16,
      keyword,
      module: isSchoolLive ? 1 : '',
    }).catch(() => {
      this.updateLoading(false)
    })
    this.updateLoading(false)
    global.$showLoading(false)
    if (!res) {
      global.$message('系统异常', { variant: 'error' })
      return
    }
    if (+res.code === -4) {
      return
    } else if (+res.code !== 0) {
      global.$message(res.message, { variant: 'error' })
    } else if (!!res.body) {
      const data = res.body.data || []
      this.shortVideoList =
        pageNo === 1 ? [...data] : [...this.shortVideoList, ...data]
      this.pageNumberShortVideo = pageNumberShortVideo + 1
      this.updateHaveMore(data.length >= 12)
    } else {
      this.updateHaveMore(true)
    }
  }

  // 在直播列表最底部的查看更多
  @action
  public getLiveListMore = (isSchoolLive?: boolean) => {
    if (!this.haveMore) {
      return
    }
    this.getLiveList(this.pageNumberLive, isSchoolLive)
  }

  // 回放
  @action
  public getLiveBackList = async (pageNumberPlayBack: number) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const { code, body, message }: any = await SearchList.getBackListMore(
      pageNumberPlayBack,
      searchWord
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === -4) {
      return
    } else if (+code !== 0) {
      global.$message(message, { variant: 'error' })
    } else if (!!body) {
      const temp = body.page || {}
      const data = temp.data || []
      this.updatePlayBackList([...this.playBackList, ...data]),
        this.updatePageNumberPlayBack(this.pageNumberPlayBack + 1)
      this.updateHaveMore(data.length >= 15)
    } else {
      this.updateHaveMore(true)
    }
  }
  //  回放列表最底部查看更多
  @action
  public getPlayBackListMore = () => {
    if (!this.haveMore) {
      return
    }
    this.getLiveBackList(this.pageNumberPlayBack)
  }
  // 企业课
  @action
  public getEnterpriseList = async (pageNumberEnterPrise: number) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const { code, body, message }: any = await SearchList.getEnterPriseListMore(
      pageNumberEnterPrise,
      searchWord
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === -4) {
      return
    } else if (+code !== 0) {
      global.$message(message, { variant: 'error' })
    } else if (!!body) {
      const data = body.courseArr || []
      this.updateEnterPriseList([...this.enterPriseList, ...data]),
        this.updatePageNumberEnterPrise(this.pageNumberEnterPrise + 1),
        this.updateHaveMore(data.length >= 15)
    } else {
      this.updateHaveMore(true)
    }
  }
  // 企业列表最底部查看更多
  @action
  public getEnterpriseListMore = () => {
    if (!this.haveMore) {
      return
    }
    this.getEnterpriseList(this.pageNumberEnterPrise)
  }
  // 专题
  public getSeminarList = async (pageNumberSeminar: number) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const { code, body, message }: any = await SearchList.getSeminarListMore(
      pageNumberSeminar,
      searchWord
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === -4) {
      return
    } else if (+code !== 0) {
      global.$message(message, { variant: 'error' })
    } else if (!!body) {
      const temp = body || {}
      const data = temp.data || []
      this.updateSeminarList([...this.seminarList, ...data]),
        this.updatePageNumberSeminar(this.pageNumberSeminar + 1),
        this.updateHaveMore(data.length >= 15)
    } else {
      this.updateHaveMore(true)
    }
  }
  // 专题列表最底部查看更多
  @action
  public getSeminarListMore = () => {
    if (!this.haveMore) {
      return
    }
    this.getSeminarList(this.pageNumberSeminar)
  }

  // 资讯
  public getInforList = async (pageNumberInfor: number) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const { code, body, message }: any = await SearchList.getInforListMore(
      pageNumberInfor,
      searchWord
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === -4) {
      return
    } else if (+code !== 0) {
      global.$message(message, { variant: 'error' })
    } else if (!!body) {
      const temp = body || {}
      const data = temp.data || []
      this.updateInforList([...this.inforList, ...data]),
        this.updatePageNumberInfor(this.pageNumberInfor + 1),
        this.updateHaveMore(data.length >= 15)
    } else {
      this.updateHaveMore(true)
    }
  }
  // 资讯列表最底部查看更多
  @action
  public getInforListMore = () => {
    if (!this.haveMore) {
      return
    }
    this.getInforList(this.pageNumberInfor)
  }
  // 面授班
  public getTrainList = async (pageNumberTrain: number) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const { code, body, message }: any = await SearchList.getTrainListMore(
      pageNumberTrain,
      searchWord
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === -4) {
      return
    } else if (+code !== 0) {
      global.$message(message, { variant: 'error' })
    } else if (!!body) {
      const temp = body || {}
      const data = temp.data || []
      this.updateTrainList([...this.trainList, ...data]),
        this.updatePageNumberTrain(this.pageNumberTrain + 1),
        this.updateHaveMore(data.length >= 15)
    } else {
      this.updateHaveMore(true)
    }
  }

  // 面授班列表最底部查看更多
  @action
  public getTrainListMore = () => {
    if (!this.haveMore) {
      return
    }
    this.getTrainList(this.pageNumberTrain)
  }

  // 文库
  public getKnowledgeList = async (pageNumberKnowledge: number) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const tabId = 19
    const { code, body, message }: any = await SearchList.searchItem(
      pageNumberKnowledge,
      searchWord,
      tabId
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === -4) {
      return
    } else if (+code !== 0) {
      global.$message(message, { variant: 'error' })
    } else if (!!body) {
      const temp = body || {}
      const data = temp.knowledgeBase.data || []
      this.updateKnowledgeList([...this.knowledgeList, ...data]),
        this.updatePageNumberKnowledge(this.pageNumberKnowledge + 1),
        this.updateHaveMore(data.length >= 15)
    } else {
      this.updateHaveMore(true)
    }
  }
  @action
  public getKnowledgeListMore = () => {
    if (!this.haveMore) {
      return
    }
    this.getKnowledgeList(this.pageNumberKnowledge)
  }

  // 文件
  public getFileList = async (pageNumberFile: number) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const tabId = 20
    const { code, body, message }: any = await SearchList.searchItem(
      pageNumberFile,
      searchWord,
      tabId
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === -4) {
      return
    } else if (+code !== 0) {
      global.$message(message, { variant: 'error' })
    } else if (!!body) {
      const temp = body || {}
      const data = temp.knowledgeBaseFile.data || []
      this.updateFileList([...this.fileList, ...data]),
        this.updatePageNumberFile(this.pageNumberFile + 1),
        this.updateHaveMore(data.length >= 15)
    } else {
      this.updateHaveMore(true)
    }
  }
  @action
  public getFileListMore = () => {
    if (!this.haveMore) {
      return
    }
    this.getFileList(this.pageNumberFile)
  }
  // 圈子
  public getTopicList = async (pageNumberTopic: number) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const tabId = 21
    const { code, body, message }: any = await SearchList.searchItem(
      pageNumberTopic,
      searchWord,
      tabId
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === 0) {
      if (!!body) {
        const temp = body || {}
        const data = temp.iKnowTopic.data || []
        this.updateTopicList([...this.topicList, ...data]),
          this.updatePageNumberTopic(this.pageNumberTopic + 1),
          this.updateHaveMore(data.length >= 15)
      } else {
        this.updateHaveMore(true)
      }
    } else {
      if (+code === -4) {
        return
      } else {
        global.$message(message, { variant: 'error' })
      }
    }
  }
  @action
  public getTopicListMore = () => {
    if (!this.haveMore) {
      return
    }
    this.getTopicList(this.pageNumberTopic)
  }
  // 帖子
  public getPostList = async (pageNumberPost: number) => {
    const searchWord = this.searchWord
    global.$showLoading(true)
    this.updateLoading(true)
    const tabId = 22
    const { code, body, message }: any = await SearchList.searchItem(
      pageNumberPost,
      searchWord,
      tabId
    )
    this.updateLoading(false)
    global.$showLoading(false)
    if (+code === 0) {
      if (!!body) {
        const temp = body || {}
        const data = temp.iKnowPost.data || []
        this.updatePostList([...this.postList, ...data]),
          this.updatePageNumberPost(this.pageNumberPost + 1),
          this.updateHaveMore(data.length >= 15)
      } else {
        this.updateHaveMore(true)
      }
    } else {
      if (+code === -4) {
        return
      } else {
        global.$message(message, { variant: 'error' })
      }
    }
  }
  @action
  public getPostListMore = () => {
    if (!this.haveMore) {
      return
    }
    this.getPostList(this.pageNumberPost)
  }
}

export default new Search()
